<template>
  <div>
    <navbar :hasSearch="true" />
    <div id="content">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body">
              <h3>Releases</h3>
              <hr />
              <div class="row">
                <div class="col">
                  <nav>
                    <div
                      class="nav nav-tabs"
                      id="nav-tabs-meter-info"
                      role="tablist"
                      v-if="releaseVersions"
                    >
                      <a
                        v-for="group of releaseVersions.Groups"
                        :key="group.Hash"
                        class="nav-item nav-link text-sm-left"
                        :class="`${group === selectedGroup ? 'active' : ''}`"
                        :id="`${group.Group}-tab`"
                        data-toggle="tab"
                        :href="`#nav-${group.Group}`"
                        role="tab"
                        :aria-controls="`nav-${group.Group}`"
                        @click="selectedGroup = group"
                      >
                        {{ group.Group }}
                      </a>
                    </div>
                  </nav>
                  <!-- Tab content -->
                  <!-- Meter Point Summary Start -->
                  <div class="tab-content py-2 px-2 px-sm-0">
                    <b-table striped :fields="tabelCols" :items="deployments">
                    </b-table>

                    <!-- main. row close -->
                  </div>
                  <!-- card body close -->
                </div>
                <!-- card close -->
              </div>
              <!-- main col  close -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Navbar from "@/components/Navbar.vue";
import moment from "moment";

export default {
  name: "ReleasesPage",
  components: {
    Navbar,
  },

  data() {
    return {
      selectedGroupName: null,
    };
  },

  computed: {
    ...mapState({
      releaseVersions: (state) => state.customers.releaseVersions,
    }),

    tabelCols() {
      return [
        { value: "Name", label: "Build ID" },
        { value: "SourceCodeBranch", label: "Source Code Branch" },
        { value: "BuildID", label: "Build ID" },
        { value: "Released", label: "Released" },
      ];
    },

    selectedGroup: {
      get() {
        if (this.releaseVersions && this.releaseVersions.Groups)
          return (
            this.releaseVersions.Groups.find(
              (group) => group.Group === this.selectedGroupName
            ) || this.releaseVersions.Groups[0]
          );
      },
      set(group) {
        this.selectedGroupName = group.Group;
      },
    },

    deployments() {
      if (this.selectedGroup && this.selectedGroup.Deployments)
        return this.selectedGroup.Deployments.map((deployment) => ({
          Name: deployment.Bot,
          SourceCodeBranch: deployment.Branch,
          BuildID: deployment.Build,
          Released: moment(deployment.Completed).format("DD/MM/YYYY HH:mm"),
        }));
    },

    uiVersion() {
      return require("../../package.json").version;
    },
  },
};
</script>

<style lang="css" scoped>
</style>